import { SVGProps } from "react";

const People = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={58}
    height={58}
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M43.4994 17.3035C43.3544 17.2793 43.1852 17.2793 43.0402 17.3035C39.7052 17.1827 37.0469 14.4518 37.0469 11.0685C37.0469 7.61267 39.826 4.8335 43.2819 4.8335C46.7377 4.8335 49.5169 7.63683 49.5169 11.0685C49.4927 14.4518 46.8344 17.1827 43.4994 17.3035Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.01 34.8967C44.3208 35.4526 47.97 34.8726 50.5317 33.1567C53.9392 30.8851 53.9392 27.1634 50.5317 24.8917C47.9458 23.1759 44.2483 22.5959 40.9375 23.1759"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4238 17.3035C14.5688 17.2793 14.7379 17.2793 14.8829 17.3035C18.2179 17.1827 20.8763 14.4518 20.8763 11.0685C20.8763 7.61267 18.0971 4.8335 14.6413 4.8335C11.1854 4.8335 8.40625 7.63683 8.40625 11.0685C8.43042 14.4518 11.0888 17.1827 14.4238 17.3035Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9132 34.8967C13.6024 35.4526 9.95323 34.8726 7.39156 33.1567C3.98406 30.8851 3.98406 27.1634 7.39156 24.8917C9.9774 23.1759 13.6749 22.5959 16.9857 23.1759"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.9994 35.3558C28.8544 35.3316 28.6852 35.3316 28.5402 35.3558C25.2052 35.2349 22.5469 32.5041 22.5469 29.1207C22.5469 25.6649 25.326 22.8857 28.7819 22.8857C32.2377 22.8857 35.0169 25.6891 35.0169 29.1207C34.9927 32.5041 32.3344 35.2591 28.9994 35.3558Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9697 42.9681C18.5622 45.2398 18.5622 48.9615 21.9697 51.2331C25.8364 53.819 32.168 53.819 36.0347 51.2331C39.4422 48.9615 39.4422 45.2398 36.0347 42.9681C32.1922 40.4065 25.8364 40.4065 21.9697 42.9681Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default People;
